const STYLES = {
  awaiting_payment: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  pending: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  processing: "bg-sky-400/15 text-sky-300 border-sky-400/30",
  supplier_ordered: "bg-sky-400/15 text-sky-300 border-sky-400/30",
  shipped: "bg-amber-400/15 text-amber-300 border-amber-400/30",
  delivered: "bg-emerald-400/15 text-emerald-300 border-emerald-400/30",
  paid: "bg-emerald-400/15 text-emerald-300 border-emerald-400/30",
  requested: "bg-sky-400/15 text-sky-300 border-sky-400/30",
  label_issued: "bg-amber-400/15 text-amber-300 border-amber-400/30",
  approved: "bg-emerald-400/15 text-emerald-300 border-emerald-400/30",
  rejected: "bg-rose-400/15 text-rose-300 border-rose-400/30",
  received: "bg-amber-400/15 text-amber-300 border-amber-400/30",
  refunded: "bg-emerald-400/15 text-emerald-300 border-emerald-400/30",
  failed: "bg-rose-400/15 text-rose-300 border-rose-400/30",
};

const LABELS = {
  supplier_ordered: "Supplier ordered",
  label_issued: "Label issued",
  awaiting_payment: "Awaiting payment",
};

export const StatusBadge = ({ status, testid }) => (
  <span
    data-testid={testid || `status-${status}`}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold capitalize ${STYLES[status] || STYLES.pending}`}
  >
    {LABELS[status] || status?.replace(/_/g, " ")}
  </span>
);

export const ChannelBadge = ({ channel }) => {
  const map = {
    shop: { label: "TrendDrop", cls: "bg-amber-400/15 text-amber-300 border-amber-400/30" },
    ebay: { label: "eBay", cls: "bg-sky-400/15 text-sky-300 border-sky-400/30" },
    tiktok: { label: "TikTok Shop", cls: "bg-rose-400/15 text-rose-300 border-rose-400/30" },
  };
  const c = map[channel] || map.shop;
  return (
    <span data-testid={`channel-${channel}`} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${c.cls}`}>
      {c.label}
    </span>
  );
};
